import React, { useState } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash.omit';

import {
  CARD_ELEMENT_TYPE,
  ORIENTATION,
} from '../../../../../../../../services/cards/constants';
import {
  getInchMeasurements,
  getPercentMeasurements,
} from '../../../CardDesignerCardElementFrame/helpers';
import MeasurementsUpdateModal from './components/MeasurementsUpdateModal';
import Button from '../../../../../../Button';

const propTypes = {
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
    side: PropTypes.string.isRequired,
  }),
  cardPrintSize: PropTypes.shape({
    id: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  cardOrientation: PropTypes.oneOf(Object.values(ORIENTATION)),
  localElement: PropTypes.shape({
    cardElement: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    cardElementConfiguration: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  setLocalElement: PropTypes.func.isRequired,
  onCardElementUpdate: PropTypes.func.isRequired,
};
const CardDesignerCardElementMeasurementControls = ({
  element,
  cardPrintSize,
  cardOrientation,
  localElement,
  setLocalElement,
  onCardElementUpdate,
}) => {
  const [measurementsModalOpen, setMeasurementsModalOpen] = useState(false);
  const { cardElement } = element;
  const { frame } = cardElement ?? {};

  const inchMeasurements = getInchMeasurements(
    frame,
    cardPrintSize,
    cardOrientation,
  );

  if (cardElement.type !== CARD_ELEMENT_TYPE.PHOTO) {
    return null;
  }

  if (!inchMeasurements?.width) {
    return null;
  }

  return (
    <div className="card-designer-element-measurements">
      <Button btnStyle="reset" onClick={() => setMeasurementsModalOpen(true)}>
        {inchMeasurements.width} &times; {inchMeasurements.height}in
      </Button>
      <MeasurementsUpdateModal
        forceOpen={measurementsModalOpen}
        onClose={() => setMeasurementsModalOpen(false)}
        currentWidth={inchMeasurements.width}
        currentHeight={inchMeasurements.height}
        onSubmit={({ width, height }) => {
          const {
            width: newFrameWidth,
            height: newFrameHeight,
          } = getPercentMeasurements(
            width,
            height,
            cardPrintSize,
            cardOrientation,
          );

          setLocalElement({
            ...localElement,
            cardElement: {
              ...localElement.cardElement,
              frame: {
                ...frame,
                width: newFrameWidth,
                height: newFrameHeight,
              },
            },
          });

          onCardElementUpdate({
            cardElement: element.cardElement,
            data: {
              frame: {
                ...omit(frame, '__typename'),
                width: newFrameWidth,
                height: newFrameHeight,
              },
            },
          });
        }}
      />
    </div>
  );
};

CardDesignerCardElementMeasurementControls.propTypes = propTypes;

export default CardDesignerCardElementMeasurementControls;
